import axios from "@/app/axios";
import {ALERT, CLEAR_PURCHASE} from "@/actions/types";
import { isMobileApp } from "@/app/general";

const getInfo: (postId: number) => (dispatch: (any:any) => void) => Promise<any> = (postId) => {
    return (dispatch) => {
        return axios.get(`api/purchase/info/${postId}`)
            .then((res) => {
                return res.data as IPurchaseInfo;
            }).catch(res => {
                dispatch({
                    type: ALERT,
                    payload: { message: {...res.response.data} }
                });
                dispatch({
                    type: CLEAR_PURCHASE
                });
                return res;
            });
    };
};

const purchase: (pid: number, include_wallet: boolean) => (dispatch: (any:any) => void) => Promise<any> = (pid, include_wallet) => {
    const is_mobile_app = isMobileApp();
    return async (dispatch) => {
        return axios.post(`api/purchase`, { pid, include_wallet, is_mobile_app })
            .then((res) => {
                dispatch({
                    type: ALERT,
                    payload: { message: {...res.data} }
                });
            }).catch(res => {
                dispatch({
                    type: ALERT,
                    payload: { message: {...res.response.data} }
                });
                dispatch({
                    type: CLEAR_PURCHASE
                });
                return res;
            });
    }
};

const PurchaseService = {
    purchase,
    getInfo
};

export default PurchaseService;
